module.exports = __webpack_public_path__ + "img/main1.5d5d7f2b.png";